<template>
  <v-container fluid>

    <LoadingModal :is-loading="isLoading" custom-text="Идет загрузка"/>

    <v-row>
      <div class='header'>
        <h2>Публикации</h2>
      </div>

      <div class='horizontal-rule' />

      <v-container v-if="!failedToLoad">
      <v-row class="justify-start">
        <v-pagination
            v-model="page"
            :length="maxPage + 1"
            total-visible="7"
        ></v-pagination>
      </v-row>
      </v-container>

      <v-row class="pa-0" v-for="item in articles" :key="item.id">
        <v-col cols="12" class="pb-0">
          <v-card outlined>
            <vt-icon>
              <div v-if='isAdmin'>
                <v-btn @click='deleteArticleById(item.id)' class='float-right' icon>
                  <v-icon color='red'>mdi-close-circle</v-icon>
                </v-btn>
                <v-btn @click='getThisArticle(item)' class='float-right' icon>
                  <v-icon color='primary'>mdi-pencil-circle</v-icon>
                </v-btn>
              </div>
            </vt-icon>
            <v-card-title class="title-text">
              {{ item.title }}
            </v-card-title>
            <v-card-subtitle class="pt-0 pb-1">
              <div class="d-flex align-center justify-space-between">

                <v-chip-group class="pa-0">
                  <v-chip
                      v-for="tag in item.tags"
                      :key="tag"
                      small
                  >
                    {{ tag }}
                  </v-chip>
                </v-chip-group>

                <v-btn v-if="item.link && !/^\s*$/.test(item.link)"
                       :href="item.link"
                       target="_blank"
                       text color="primary"
                >
                  Перейти к публикации
                </v-btn>
              </div>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>

    </v-row>

    <v-dialog
      v-model='showModal'
      fullscreen
      :scrim='false'
      transition='dialog-bottom-transition'
    >
      <v-card tile>
        <v-toolbar
          tile
          dark
          color='primary'

        >
          <v-btn
            icon
            dark
            @click='showModal = false'
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Редактирование публикации</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <CreationForm @updateArticle='updateArticle' :article-to-edit='articleToEdit' :is-updating='true'
                      :key='articleToEdit.id' class='pa-5 mt-0' />
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { deleteArticle, fetchArticles } from '@/services/articleAPI';
import CreationForm from '@/components/ArticleCreationPageComponents/CreationForm';
import LoadingModal from "@/components/UI/LoadingModal";

export default {
  name: 'ArticlesPage',
  components: { CreationForm, LoadingModal },

  data() {
    return {
      articles: [],
      showModal: false,
      articleToEdit: {},
      page: 1,
      maxPage: 0,

      isLoading: false,
      failedToLoad: false,
    };
  },

  computed: {
    isAdmin() {
      return this.$store.getters.getIsViewAdminPanel;
    },
  },

  methods: {
    async deleteArticleById(id) {
      this.articles = this.articles.filter(article => article.id !== id);
      await deleteArticle(id);
      if(this.articles.length === 0 && (this.page - 1 !== 0)) this.page--
    },

    getThisArticle(item) {
      this.articleToEdit = item;
      this.showModal = true;
    },

    async updateArticle(boolean) {
      this.showModal = boolean;
      await fetchArticles(null, null, this.page - 1).then((data) =>
      {
        this.articles = data.body
        this.maxPage = data.maxPage
      }).finally(() => this.isLoading = false);
    },

    changePage() {
      console.log(this.page);
    }

  },

  watch: {
    async page() {
      this.isLoading = true
      await fetchArticles(null, null, this.page - 1)
          .then((data) =>
          {
            this.articles = data.body
            this.maxPage = data.maxPage
          }).finally(() => this.isLoading = false);
    }
  },

  async mounted() {
    this.isLoading = true
    await fetchArticles(null, null, this.page - 1)
        .then((data) =>
        {
          this.articles = data.body
          this.maxPage = data.maxPage
        })
        .catch((e) =>
        {
          if (e.response.status === 404) this.failedToLoad = true
        }).finally(() => this.isLoading = false)
    ;
  },
};
</script>

<style scoped>
.title-text {
  font-size: 1rem;
  line-height: 1;
  word-wrap: break-word;
  hyphens: auto;
}
.v-btn {
  height: 26px !important;
  font-size: 0.8rem !important;
}
#chip-group-content-padding {
  padding: 0 !important;
}
</style>